<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-LuoDiDeng1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.51581 1.92285C7.75456 1.92285 7.13745 2.53996 7.13745 3.30121V3.46192C7.13745 6.02595 8.98154 8.15926 11.4158 8.60792V21.7566H9.66467C9.17866 21.7566 8.78467 22.1506 8.78467 22.6366C8.78467 23.1226 9.17866 23.5166 9.66467 23.5166H15.0759C15.5619 23.5166 15.9559 23.1226 15.9559 22.6366C15.9559 22.1506 15.5619 21.7566 15.0759 21.7566H13.1758V8.63316C13.511 8.58138 13.8357 8.49777 14.1467 8.38553V9.66199C14.1467 10.148 14.5407 10.542 15.0267 10.542C15.5127 10.542 15.9067 10.148 15.9067 9.66199V7.31896C16.9495 6.36239 17.6031 4.9885 17.6031 3.46193V3.30121C17.6031 2.53996 16.986 1.92285 16.2248 1.92285H8.51581ZM9.09214 3.64355C8.98651 3.64355 8.90088 3.72919 8.90088 3.83482C8.90088 5.56016 10.2995 6.95882 12.0249 6.95882H12.7157C14.4411 6.95882 15.8397 5.56016 15.8397 3.83482C15.8397 3.72919 15.7541 3.64355 15.6485 3.64355H9.09214Z"/></svg>
</template>
<script>

export default {
  name: 'IconLuoDiDeng1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
